<template>
  <ConfirmModal ref="confirmModal" @hidden="closeEmit">
    <img
      src="/src/assets/images/icons/toast/warning.svg"
      width="40"
      height="40"
      alt=""
    />
    <h3>{{ $t('wkis.wkis_warning_popup.title') }}</h3>

    <p v-html="$t('wkis.wkis_warning_popup.text')"></p>

    <div class="modal-actions">
      <button class="btn btn-outline-secondary" type="button" @click="close">
        {{ $t('wkis.wkis_warning_popup.close_btn') }}
      </button>

      <a class="btn btn-danger" :href="wkisLink" @click="close">
        {{ $t('wkis.wkis_warning_banner.sign_in_with_wkis') }}
      </a>

      <div class="counter">
        <span>{{ wkisWarningAttemptsLeft }}</span>
        {{ $t('wkis.wkis_warning_popup.attempts_left') }}
      </div>
    </div>
  </ConfirmModal>
</template>

<script>
import ConfirmModal from '@/components/ConfirmModal/index.vue'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'SignInWithWkisWarningPopup',

  components: {
    ConfirmModal,
  },

  emits: ['accept'],

  mounted() {
    this.open()
  },

  computed: {
    wkisLink() {
      return `${import.meta.env.VITE_API_URL}/wkis_saml/init`
    },

    ...mapGetters('wkis', ['wkisWarningAttemptsLeft']),
  },

  methods: {
    /**
     * Open the modal
     */
    open() {
      this.$refs.confirmModal.open()
    },

    /**
     * Close the modal
     */
    close() {
      this.$refs.confirmModal.close()
    },

    /**
     * Handles the close event by incrementing the remaining attempts.
     */
    closeEmit() {
      this.incrementAttemptsLeft()
    },

    ...mapActions('wkis', ['incrementAttemptsLeft']),
  },
}
</script>

<style scoped lang="scss">
.counter {
  margin-top: 1.5rem;
  margin-bottom: -1.5rem;
  color: $red-500;
  font-size: $font-size-sm;
  font-weight: $font-weight-semibold;
  text-align: center;
}

p:deep a {
  color: $gray-800;
  font-weight: $font-weight-semibold;
}

img {
  margin-bottom: 1.25rem;
}
</style>
